<template>
  <div class="wrapper">
    <vueGradientPicker
      v-if="gradientType === 'linear'"
      v-model="gradient"
      :themeKey="request_prefix"
      @update="changeColorHandle"
    />
    <vueRadialGradientPicker
      v-if="gradientType === 'radial'"
      v-model="gadialGradient"
      :themeKey="request_prefix"
      @update="changeRadialColorHandle"
    />
  </div>
</template>

<script>
import "../../common.css"
import vueGradientPicker from "./component/vueGradientPicker"
import vueRadialGradientPicker from "./component/vueRadialGradientPicker.vue"
import LinearGradient from "./component/LinearGradient"
import RadialGradient from "./component/RadialGradient"

export default {
  name: "cxBgColor",
  props: {
    data: {
      type: Object,
      require: true
    },
    gradientType: {
      type: String,
      require: true,
      default: "linear"
    },
    themeKey: {
      type: String,
      require: true
    }
  },
  components: {
    vueGradientPicker,
    vueRadialGradientPicker
  },
  computed: {
    gradient() {
      const gradient = new LinearGradient({
        ...this.data,
        limit: 5
      })
      return gradient
    },
    gadialGradient() {
      const gadialGradient = new RadialGradient({
        ...this.data,
        limit: 5
      })
      return gadialGradient
    }
  },
  methods: {
    changeColorHandle(data) {
      this.$emit("update:data", data)
    },
    changeRadialColorHandle(data) {
      this.$emit("update:data", data)
    }
  }
}
</script>

<style scoped></style>
